var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1232_5467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1232_5467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8665 12.0334H7.84984V11.8C7.84984 11.6 7.79984 11.4222 7.69984 11.2667C7.59984 11.1111 7.47206 11.0056 7.3165 10.95C6.96095 10.8278 6.68317 10.7472 6.48317 10.7084C6.28317 10.6695 6.08873 10.65 5.89984 10.65C5.68873 10.65 5.46373 10.675 5.22484 10.725C4.98595 10.775 4.7165 10.85 4.4165 10.95C4.24984 11.0056 4.1165 11.1111 4.0165 11.2667C3.9165 11.4222 3.8665 11.6 3.8665 11.8V12.0334ZM9.4665 10.9167H12.2998V10.0834H9.4665V10.9167ZM5.89984 10.0834C6.14984 10.0834 6.36234 9.99586 6.53734 9.82086C6.71234 9.64586 6.79984 9.43336 6.79984 9.18336C6.79984 8.93336 6.71234 8.72086 6.53734 8.54586C6.36234 8.37086 6.14984 8.28336 5.89984 8.28336C5.64984 8.28336 5.43734 8.37086 5.26234 8.54586C5.08734 8.72086 4.99984 8.93336 4.99984 9.18336C4.99984 9.43336 5.08734 9.64586 5.26234 9.82086C5.43734 9.99586 5.64984 10.0834 5.89984 10.0834ZM9.4665 9.03336H12.2998V8.20002H9.4665V9.03336ZM0.916504 15.0834V4.23336H6.08317V0.900024H9.93317V4.23336H15.0998V15.0834H0.916504ZM2.48317 13.5167H13.5165V5.81669H9.89984V7.31669H6.09984V5.81669H2.48317V13.5167ZM7.53317 5.86669H8.48317V2.35002H7.53317V5.86669Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.cbd512111efc50d9cd9b6e7d23026049.svg";
export { ForwardRef as ReactComponent };